import { touchHitAreaSx, touchTargetSx } from './touchTarget';

const base = {
  // MUI's vertical padding varies by `size` and again by `variant`; the design fixes
  // the height and centres the label, so it has to go or the sizes disagree.
  py: 0,
  textTransform: 'none',
  fontWeight: 500,
  // `typography.button` adds 0.025em to every MUI Button; the design's has none.
  letterSpacing: 'normal',
  whiteSpace: 'nowrap',
  minWidth: 'auto',
  borderRadius: '0.25rem',
  '& .MuiButton-startIcon': { margin: 0 },
  '& .MuiButton-endIcon': { margin: 0 },
  // MUI sizes its own icons through a rule of this exact specificity, so restating it
  // is what keeps a MUI glyph at 14px instead of MUI's own 18–22px.
  '& .MuiButton-startIcon > *:nth-of-type(1)': { fontSize: '0.875rem' },
  '& .MuiButton-endIcon > *:nth-of-type(1)': { fontSize: '0.875rem' },
  ...touchTargetSx,
} as const;

export const buttonSizeSx = {
  sm: {
    ...base,
    minHeight: '1.75rem',
    px: 1.25,
    gap: 0.75,
    fontSize: '0.8rem',
    lineHeight: 1.4,
  },
  md: {
    ...base,
    minHeight: '2rem',
    px: 1.5,
    gap: 1,
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
} as const;

export const cardButtonSx = {
  ...buttonSizeSx.md,
  '@media (hover: none)': { minHeight: buttonSizeSx.md.minHeight },
  ...touchHitAreaSx,
  '& .MuiButton-startIcon > *:nth-of-type(1)': { fontSize: '1.125rem' },
} as const;

export const secondaryButtonSx = {
  color: 'text.primary',
  borderColor: 'background.dividerStrong',
  backgroundColor: 'common.white',
  '&:hover': {
    borderColor: 'background.dividerStrong',
    backgroundColor: 'highlight.neutral',
  },
  '&:active': { backgroundColor: 'background.divider' },
  '&.Mui-disabled': {
    color: 'text.lightGrey',
    borderColor: 'background.dividerStrong',
    backgroundColor: 'common.white',
  },
} as const;

export const ghostButtonSx = {
  color: 'text.secondary',
  '&:hover': {
    color: 'text.primary',
    backgroundColor: 'highlight.neutral',
  },
  '&:active': { backgroundColor: 'background.divider' },
  '&.Mui-disabled': { color: 'text.lightGrey' },
} as const;
